import httpDao from "../infrastructure/httpDao";
import {
  AiChatSession,
  AiChatMessage,
  AiChatMode,
} from "../types/ai-assistant";

export const aiAssistantRepository = {
  async getSessions(): Promise<AiChatSession[]> {
    const res = await httpDao.get<AiChatSession[]>("/ai-assistant/sessions");
    return res.data;
  },

  async createSession(
    mode: AiChatMode,
    title?: string
  ): Promise<AiChatSession> {
    const res = await httpDao.post<AiChatSession>("/ai-assistant/sessions", {
      mode,
      ...(title ? { title } : {}),
    });
    return res.data;
  },

  async getSession(id: string): Promise<AiChatSession> {
    const res = await httpDao.get<AiChatSession>(
      `/ai-assistant/sessions/${id}`
    );
    return res.data;
  },

  async updateSessionTitle(id: string, title: string): Promise<AiChatSession> {
    const res = await httpDao.patch<AiChatSession>(
      `/ai-assistant/sessions/${id}`,
      { title }
    );
    return res.data;
  },

  async deleteSession(id: string): Promise<void> {
    await httpDao.delete(`/ai-assistant/sessions/${id}`);
  },

  async sendMessage(
    sessionId: string,
    message: string,
    context?: { currentRoute?: string }
  ): Promise<AiChatMessage> {
    const res = await httpDao.post<{ content: string }>(
      `/ai-assistant/sessions/${sessionId}/messages`,
      {
        message,
        ...(context?.currentRoute
          ? { currentRoute: context.currentRoute }
          : {}),
      }
    );
    return {
      id: Date.now().toString(),
      sessionId,
      role: "assistant",
      content: res.data.content,
      createdAt: new Date().toISOString(),
    };
  },
};
